module.exports = __webpack_public_path__ + "static/img/live.12d7d4bc.png";